import { render, staticRenderFns } from "./ViewAdminAppeals.vue?vue&type=template&id=76933a03&"
import script from "./ViewAdminAppeals.vue?vue&type=script&lang=js&"
export * from "./ViewAdminAppeals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports